import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { userReducer } from "./reducers/users.reducer";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import { eventsReducer } from "./reducers/events.reducer";
import { forumReducer } from "./reducers/forum.reducer";
import { groupsReducer } from "./reducers/groups.reducer";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { chatReducer } from "./reducers/chats.reducer";
import { postsReducer } from "./reducers/posts.reducer";
import { galleryReducer } from "./reducers/gallery.reducer";
import { documentsReducer } from "./reducers/documents.reducer";
import { aboutMeReducer } from "./reducers/aboutMe.reducer";

const rootPersistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  events: eventsReducer,
  forums: forumReducer,
  groups: groupsReducer,
  chats: chatReducer,
  posts: postsReducer,
  gallery: galleryReducer,
  documents: documentsReducer,
  aboutMe: aboutMeReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;

export const persistor = persistStore(store);
